import { useCallback } from 'react';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { useGeo } from '@repo/ui/GeoTargeting/GeoProvider';
import { MobileFilters } from './index';

export type MobileFiltersWithGeoProps = {
  slug: string;
  initialLocation?: StateAbbreviation;
  analyticsProps: {
    actionSection: string;
    pageIdentifier: string;
  };
  isFiltersInHeader?: boolean;
};

export const MobileFiltersWithGeo = ({
  slug,
  initialLocation,
  analyticsProps,
  isFiltersInHeader,
}: MobileFiltersWithGeoProps) => {
  const { setRegionCode, initialRegionCode, regionCode } = useGeo();

  const handleLocationReset = useCallback(() => {
    setRegionCode(initialRegionCode as StateAbbreviation);
  }, [initialRegionCode, setRegionCode]);

  return (
    <MobileFilters
      slug={slug}
      initialLocation={initialLocation}
      analyticsProps={analyticsProps}
      onLocationReset={handleLocationReset}
      initialClientRegion={initialRegionCode}
      regionCode={regionCode}
      isFiltersInHeader={isFiltersInHeader}
    />
  );
};
